"use client";

import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/axios";
import type { User } from "@/lib/types/user";
import { useAuthStore } from "@/stores/authStore";

export function useMe() {
  const accessToken = useAuthStore((s) => s.accessToken);

  return useQuery({
    queryKey: ["auth", "me"],
    queryFn: async () => {
      const { data } = await api.get<{ user: User }>("/api/auth/me");

      return data.user;
    },
    enabled: Boolean(accessToken),
  });
}
